import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarmElement,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';

export function P00061Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('wpSAlarme') === 1) {
    const titles = [
      'P00061.card.state.fonctionnement.title.cold',
      'P00061.card.state.fonctionnement.title.hot',
      'P00061.card.state.fonctionnement.title.auto',
    ];

    const title = titles[getValue('wpPModeFonctionnementTemperature') ?? 0];

    // Codes défauts température entrée
    if (getValue('wpSDefautsPrincipauxCodeP01') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.entree',
      });
    }

    // Codes défauts température sortie
    if (getValue('wpSDefautsPrincipauxCodeP02') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.sortie',
      });
    }

    // Codes défauts température ambiante
    if (getValue('wpSDefautsPrincipauxCodeP04') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.ambiante',
      });
    }

    // Codes défauts température évaporateur
    if (getValue('wpSDefautsPrincipauxCodeP05') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.evaporateur',
      });
    }

    // Codes défauts température compresseur aspiration
    if (getValue('wpSDefautsPrincipauxCodeP07') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.compresseur.aspiration',
      });
    }

    // Codes défauts température compresseur échappement
    if (getValue('wpSDefautsPrincipauxCodeP081') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.compresseur.echappement',
      });
    }

    // Codes défauts compresseur surintensité
    if (getValue('wpSDefautsPrincipauxCodeE051') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.compresseur.surintensite',
      });
    }

    // Codes défauts pression haute
    if (getValue('wpSDefautsPrincipauxCodeE01') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.pression.high',
      });
    }

    // Codes défauts pression basse
    if (getValue('wpSDefautsPrincipauxCodeE02') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.pression.low',
      });
    }

    // Codes défauts débit eau
    if (getValue('wpSDefautsPrincipauxCodeE03') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.debiteau',
      });
    }

    // Codes défauts antigel primaire
    if (getValue('wpSDefautsPrincipauxCodeE19') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.antigel.primaire',
      });
    }

    // Codes défauts antigel secondaire
    if (getValue('wpSDefautsPrincipauxCodeE29') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.antigel.secondaire',
      });
    }

    // Codes défauts antigel
    if (getValue('wpSDefautsPrincipauxCodeE07') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.antigel',
      });
    }

    // Codes défauts température décharge
    if (
      getValue('wpSRegistreDefauts2HighDischargeTemperatureProtection') === 1
    ) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.decharge',
      });
    }

    // Codes défauts différence température
    if (getValue('wpSDefautsPrincipauxCodeE06') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.temperature.difference',
      });
    }

    // Registre défauts 2 global
    if (
      getValue('wpSRegistreDefauts2CompressorOverloadProtection') !== 0 ||
      getValue('wpSRegistreDefauts2HighPressureProtection') !== 0 ||
      getValue('wpSRegistreDefauts2LowPressureProtection') !== 0 ||
      getValue('wpSRegistreDefauts2WaterFlowProtection') !== 0 ||
      getValue('wpSRegistreDefauts2AntifreezingProtection') !== 0 ||
      getValue('wpSRegistreDefauts2HighDischargeTemperatureProtection') !== 0 ||
      getValue('wpSRegistreDefauts2InputUnderVoltage') !== 0
    ) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.default.2',
      });
    }

    // Code F02
    if (getValue('wpSRegistreDefauts2ConverterBoardOffline') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f02',
      });
    }

    // Code F03
    if (getValue('wpSRegistreDefauts2IPMProtection') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f03',
      });
    }

    // Code F04
    if (getValue('wpSRegistreDefauts2CompressorStartFailure') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.codeP00061.status.code.f04',
      });
    }

    // Code F17
    if (getValue('wpSRegistreDefauts2ConverterInputLostPhase') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f17',
      });
    }

    // Code F18
    if (getValue('wpSRegistreDefauts2IPMSamplingCurrentFailure') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f18',
      });
    }

    // Code F20
    if (getValue('wpSRegistreDefauts2ConverterOverheatProtection') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f20',
      });
    }

    // Code F07
    if (getValue('wpSRegistreDefauts2ConverterDCOverVoltage') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f07',
      });
    }

    // Code F08
    if (getValue('wpSRegistreDefauts2ConverterDCUnderVoltage') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f08',
      });
    }

    // Registre défauts 3 global
    if (
      getValue('wpSRegistreDefauts3InputOverVoltage') !== 0 ||
      getValue('wpSRegistreDefauts3SamplingVoltageFailure') !== 0 ||
      getValue('wpSRegistreDefauts3OverUnderVoltageFailure') !== 0 ||
      getValue('wpSRegistreDefauts3InputOvercurrentProtection') !== 0 ||
      getValue('wpSRegistreDefauts3IpmProtection') !== 0 ||
      getValue('wpSRegistreDefauts3DCFanMotorDriverBoardProtection') !== 0
    ) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.defaut.3',
      });
    }

    // Code F12
    if (getValue('wpSRegistreDefauts3DspPfcConnectionFailure') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f12',
      });
    }

    // Code F19
    if (
      getValue('wpSRegistreDefauts3RadiatorTemperatureSensingFailure') === 1
    ) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f19',
      });
    }

    // Code F28
    if (getValue('wpSRegistreDefauts3OverUnderVoltageFailure') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f28',
      });
    }

    // Code F27
    if (getValue('wpSRegistreDefauts3PfcFailure') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f27',
      });
    }

    // Code F15
    if (getValue('wpSRegistreDefauts3IpmOverheatProtection') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f15',
      });
    }

    // Code F16
    if (getValue('wpSRegistreDefauts3WeakMagneticProtection') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f16',
      });
    }

    // Code F24
    if (getValue('wpSRegistreDefauts3InputOverCurrentWarning') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f24',
      });
    }

    // Code F22
    if (getValue('wpSRegistreDefauts3ConverterOverheatWarning') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f22',
      });
    }

    // Code F25
    if (getValue('wpSRegistreDefauts3EepromErrorWarning') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f25',
      });
    }

    // Code F26
    if (getValue('wpSRegistreDefauts3InputCoverCurrent') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.f26',
      });
    }

    // Registre défauts 4 global
    const registreDefauts4Values = [
      getValue('wpSRegistreDefauts4AntiFreezingProtection'),
      getValue('wpSRegistreDefauts4AntiFreezingProtectionHeatingMode'),
      getValue('wpSRegistreDefauts4ECFanMotorSignalFailure'),
      getValue('wpSRegistreDefauts4FanMotor1Failure'),
      getValue('wpSRegistreDefauts4FanMotor2Failure'),
      getValue('wpSRegistreDefauts4DCFanMotorCommunicationFailure'),
      getValue('wpSRegistreDefauts4InletOutletTempDifferenceTooMuch'),
      getValue('wpSRegistreDefauts4LowAmibentTempProtection'),
      getValue('wpSRegistreDefauts4CoilTempSensor2Failure'),
    ];

    if (registreDefauts4Values.some((val) => val !== 0)) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.code.4',
      });
    }

    // Connexion passerelle
    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00061.status.passerelle.connexion',
      });
    }
  }

  return res;
}
